import React, { useMemo } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
const GiftCardDisclaimer = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    // console.log('GiftCardDisclaimer', props.bag)
    const orderIncludesGiftCard = useMemo(() => {
        var _a, _b;
        return (_b = (_a = props.bag) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.some((item) => item.isGiftCard);
    }, [(_b = (_a = props.bag) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length]);
    if (orderIncludesGiftCard || !window.gcEnableUse) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("p", { className: classNames('gc-cart-disclaimer mb-16', props.className), dangerouslySetInnerHTML: { __html: t('gc.cart.disclaimerwithlink', `If you own a Gift Card please proceed with the <a href="${props.checkouturl}"><strong>standard checkout</strong></a>.`, { 0: props.checkouturl }) } }));
};
export default GiftCardDisclaimer;
